import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { QUERY_KEYS } from '@/utils/query-keys';
import { BeraV2Service } from '@/infra/services/bera-v2';

import type { BeraRevisionOverrides, BeraRevisionType } from '@/types/Bera';
import type { Response } from '@/types';

export interface CreateBeraRevisionParams extends BeraRevisionOverrides {
	id: string;
	organization_id: string;
	company_id: string;
	revision_type: BeraRevisionType;
}

const Service = BeraV2Service.getInstance();

export function useCreateBeraRevision() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateBeraRevisionParams) => Service.createRevision(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_BERA_JOB_SUMMARY_LIST]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_BERA_VERSION_LIST]);
		},
		onError: (err: AxiosError<Response>) => {
			message.error(I18n.get(err.response?.data?.message ?? 'Failed to create the revision'));
		}
	});
}
